import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { FormBuilder, ReactiveFormsModule } from '@angular/forms'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { VehicleModelService } from '../../../../core/services/vehicle/vehicle-model/vehicle-model.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { MatProgressBar } from '@angular/material/progress-bar'

import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { PagedContactTypeResponse } from '../../../../core/models/contact-type.model'
import { PurchasesQuoteRequestService } from '../../../../core/services/purchases/purchases-quote-request/purchases-quote-request.service'
import { SupplierService } from '../../../../core/services/person/supplier/supplier.service'
import { MatTableModule } from '@angular/material/table'
import { MatCardModule } from '@angular/material/card'
import { TelefonePipe } from '../../../../shared/pipes/phone.pipes'
import { CnpjPipe } from '../../../../shared/pipes/cpnj.pipes'
import { PurchasesQuoteItemSupplierService } from '../../../../core/services/purchases/purchases-quote-item-supplier/purchases-quote-item-supplier.service'
import { MatTooltip } from '@angular/material/tooltip'
import { PurchasesQuoteSupplierService } from '../../../../core/services/purchases/purchases-quote-supplier/purchases-quote-supplier.service'
import { JsonPipe } from '@angular/common'
import { MatDivider } from '@angular/material/divider'
import { convertCurrency } from '../../../../shared/utils/utils'
import { ModalPurchasesSupplierItinerariesComponent } from '../modal-purchases-supplier-itineraries/modal-purchases-supplier-itineraries.component'
import { ModalPurchasesSupplierPriceComponent } from '../modal-purchases-supplier-price/modal-purchases-supplier-price.component'
import { ModelPurchasesQuoteTariffCreateComponent } from '../model-purchases-quote-tariff-create/model-purchases-quote-tariff-create.component'

@Component({
  selector: 'purchases-quote-supplier-tg-price',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatProgressBar,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatPaginator,
    MatRow,
    MatRowDef,
    MatTable,
    MatTableModule,
    MatCardModule,
    TelefonePipe,
    CnpjPipe,
    MatTooltip,
    JsonPipe,
    MatIcon,
    MatDivider,
  ],
  templateUrl: './purchases-quote-supplier-tg-price.component.html',
  styleUrl: './purchases-quote-supplier-tg-price.component.scss',
  providers: [VehicleModelService, VehicleTypeService],
  standalone: true,
})
export class PurchasesQuoteSupplierTgPriceComponent
  implements OnInit, AfterViewInit
{
  constructor(
    private formBuilder: FormBuilder,
    private purchasesQuoteRequestService: PurchasesQuoteRequestService,
    private purchasesQuoteSupplierService: PurchasesQuoteSupplierService,
    private purchasesQuoteItemSupplierService: PurchasesQuoteItemSupplierService,
    private supplierService: SupplierService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<PurchasesQuoteSupplierTgPriceComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
    this.proposal = data.proposal
  }

  item: any = {}
  proposal: any = {}
  loading = false
  editItem = false
  itemPurchases: any = {}

  @Output() response = new EventEmitter()

  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'supplierName',
      key: 'fornecedorNome',
      description: 'Fornecedor',
    },
    {
      keyColumn: 'cnpj',
      key: 'fornecedorCnpjCpf',
      description: 'cnpj',
    },
    {
      keyColumn: 'cost',
      key: 'custoFormatada',
      description: 'Custo',
    },
    {
      keyColumn: 'costHour',
      key: 'custoHoraExtraFormatada',
      description: 'Custo hora extra',
    },
    {
      keyColumn: 'costKm',
      key: 'custoKmExtraFormatada',
      description: 'Custo KM extra',
    },
    {
      keyColumn: 'status',
      key: 'statusDescricao',
      description: 'Status',
    },
    // {
    //   keyColumn: 'status',
    //   key: 'descricaoStatus',
    //   description: 'Status',
    // },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  page = 1
  rows = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  tariffExist = false

  loadingEmail = false
  loadingFinish = false

  displayedColumns: string[] = [
    'supplierName',
    'cnpj',
    'cost',
    'costHour',
    'costKm',
    'status',
    'action',
  ]

  ngOnInit(): void {
    this.getListItems()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  close() {
    this.dialogRef.close()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }
  treatResponse(response: any) {
    const list = []
    this.tariffExist = false
    if (response.data) {
      for (const item of response.data) {
        const cost = item.custo == 0 ? '-' : 'R$ ' + convertCurrency(item.custo)
        const costHour =
          item.custoHoraExtra == 0
            ? '-'
            : 'R$ ' + convertCurrency(item.custoHoraExtra)
        const costKm =
          item.custoKmExtra == 0
            ? '-'
            : 'R$ ' + convertCurrency(item.custoKmExtra)
        if (item.statusId == 3) {
          this.tariffExist = true
        }
        list.push({
          ...item,
          custoFormatada: cost,
          custoHoraExtraFormatada: costHour,
          custoKmExtraFormatada: costKm,
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  // pageChanged(event: PageEvent) {
  //   this.page = event.pageIndex + 1
  //   this.rows = event.pageSize
  //   this.uploadList()
  // }

  uploadList(type = '') {
    this.getListItems()
    // if (type == 'new') {
    //   this.searchForm = { search: false, model: {} }
    // }
    // if (this.searchForm.search) {
    //   this.searchAddress()
    // } else {
    //   this.getListItems()
    // }
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  clearItem() {
    this.editItem = false
    this.itemPurchases = {}
  }

  createModel() {
    return {
      cotacaoId: this.item.id,
      statusItemCotacaoId: 0,
    }
  }

  getListItems() {
    this.loading = true
    const model = this.createModel()
    this.purchasesQuoteSupplierService
      .listPagedPurchasesQuoteSupplierByRequestId(this.item.id)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  finishQuote() {
    this.loadingFinish = true
    const model = { id: this.item.id }
    this.purchasesQuoteSupplierService
      .editFinalPurchasesQuoteSupplier(model)
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.response.emit(true)
          this.close()
        },
        error: (err: PagedContactTypeResponse) => {
          this.loadingFinish = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loadingFinish = false
        },
      })
  }

  viewItinerariesItem() {
    const dialogRef = this.dialog.open(
      ModalPurchasesSupplierItinerariesComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        width: '1000px',
        maxWidth: '1000px',
        maxHeight: '620px',
        data: { item: this.item },
      },
    )
  }

  updatePrice(item: any) {
    const dialogRef = this.dialog.open(ModalPurchasesSupplierPriceComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '1000px',
      maxWidth: '1000px',
      maxHeight: '620px',
      data: { supplier: item, quote: this.item, proposal: this.proposal },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  createTariffPrice(item: any) {
    const dialogRef = this.dialog.open(
      ModelPurchasesQuoteTariffCreateComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        width: '1000px',
        maxWidth: '1000px',
        maxHeight: '620px',
        data: { supplier: item, quote: this.item, proposal: this.proposal },
      },
    )
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
    dialogRef.componentInstance.responseCancel.subscribe((response) => {
      if (response) {
        this.close()
      }
    })
  }
}
